import React from 'react';
import DropList from './DropList'
import i18n from '../../i18n';
import {defaultPerPageOptions} from '../../constants'
import {defaultPerPage} from '../../constants'
import { trackingEvent } from "../pages/layouts/GoogleAnalytics.js"

class Paginate extends React.Component {
  constructor(props) {
    super(props);
    this.callback = this.callback.bind(this)
  }

  totalPages = () => Math.ceil(this.props.totalCount / this.props.perPage)

  perPageDefaultOptions = () => this.props.perPageOptions || defaultPerPageOptions

  pageChange(pageNumber) {
    if (pageNumber < 1 || pageNumber > this.totalPages())
      return

    this.callback(pageNumber)
  }

  callback(pageNumber, perPage) {
    this.props.callback && this.props.callback(
      this.props.nameList,
      pageNumber || 1,
      perPage || this.props.perPage
    )
  }

  perPageChange(perPage) {
    if (perPage === this.props.perPage)
      return

    this.callback(1, perPage.value)
  }

  render() {
    const {className, activePage, perPage, totalCount}= this.props
    const offset = (activePage - 1) * perPage
    const totalPages = this.totalPages()

    const from = totalCount === 0 ? 0 : offset + 1
    const to = (offset + perPage) > totalCount ? totalCount : offset + perPage

    const defaultOption = this.perPageDefaultOptions().find(opt => opt.value === perPage) || defaultPerPage

    return <div className={`paging ${className}`}>
      <div className="per-page">
        <label className="label-title">{ this.props.perPageLabel || `${i18n.t('paging.perPage')}：` }</label>
        <DropList defaultOption={defaultOption}
                  options={this.perPageDefaultOptions()}
                  onChanged={(item) => {this.perPageChange(item); trackingEvent("Bank", "フィルタ(表示件数)")}}
                  className="droplist-paginate"/>
      </div>
      <div className="content">
        <label>{from}-{to} / {totalCount}</label>
        <i className={`fas fa-angle-left ${activePage === 1 ? "disable" : ""}`} onClick={() => this.pageChange(activePage - 1)}></i>
        <i className={`fas fa-angle-right ${activePage === totalPages ? "disable" : ""}`} onClick={() => this.pageChange(activePage + 1)}></i>
      </div>
    </div>
  }
}

export default Paginate;
